module.exports = __webpack_public_path__ + "static/media/4-.e6a65968.webp";